(function (angular) {
    'use strict';

    angular.module('app')
        .service('PollVotesApi', PollVotesApi);

    PollVotesApi.$inject = [
        'settings',
        '$resource',
        'extendResource'
    ];

    function PollVotesApi(
        settings,
        $resource,
        extendResource
    ) {
        var resource = $resource(settings.apiBase + '/poll-votes/:id', {}, {
            vote: {
                method: 'POST',
            },
            get: {
                method: 'GET',
            },
            delete: {
                method: 'DELETE',
            },
            surveyvotes: {
                method: 'GET',
                url: settings.apiBase + '/poll-votes/survey',
            },
        });

        return extendResource(resource);
    }

}(angular));
